import makeStyles from '@material-ui/styles/makeStyles';

export const useStyles = makeStyles({
  stepNumber: {
    marginRight: 30,
    fontWeight: 'bold',
    fontSize: '22px',
    lineHeight: '33px',
    color: '#6A28EA',
  },
  imageWrap: {
    boxShadow: 'inset 0px 0px 4px rgba(0, 0, 0, 0.15)',
    borderRadius: '2px',
    overflow: 'hidden',
    margin: '0 16px 16px 16px',
    position: 'relative'
  },
});
